<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar SubItem"
                @click.stop="abrirModalAtualizarSubItem()"
            ></i>
        </span>
        <b-modal
            id="modalAtualizarSubItem"
            v-model="mostrarModalAtualizarSubItem"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                SubItem de Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group v-model="contratoApostilamento"  @change="alternaJustificativa($event)">
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <app-detalhe2 titulo="Nº">
                <strong>{{ subItem.ordem }}</strong>
            </app-detalhe2>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição Resumida</label>
                        <b-form-textarea
                            v-model="descricaoResumida"
                            :rows="4"
                            :maxlength="200"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é obrigatório"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Quantidade</label>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{textoInfoJustificativa}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalAtualizarSubItem()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarSubItem()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        subItem: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalAtualizarSubItem: false,
            obterSubItensAtualizados: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            descricao: '',
            descricaoResumida: '',
            valor: 0,
            quantidade: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        abrirModalAtualizarSubItem() {
            this.mostrarModalAtualizarSubItem = true
        },

        fecharModalAtualizarSubItem() {
            this.mostrarModalAtualizarSubItem = false
            this.resetAtualizarSubItem()
            if (this.obterSubItensAtualizados) {
                this.$emit('obterSubItensAtualizados')
            }
        },

        resetAtualizarSubItem() {
            this.justificativaApostilamento = ''
            this.descricao = ''
            this.descricaoResumida = ''
            this.valor = 0
            this.quantidade = 0
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.descricao = this.subItem.descricao.trim()
            this.descricaoResumida = this.subItem.descricaoResumida != null ? this.subItem.descricaoResumida.trim() : ''
            this.valor = this.subItem.valorUnitario
            this.quantidade = this.subItem.quantidade
        },

        confirmarSalvarSubItem() {
            this.$swal({
                title: 'SubItem do Contrato',
                html: `Confirma a atualização do subitem Nº <b>${this.subItem.ordem}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarSubItem()
                }
            })
        },

        salvarSubItem() {
            this.$store.dispatch('addRequest')
            let subItemAtualizadoDto = {
                idContrato: this.$route.params.contratoId,
                itemContratoId: this.subItem.itemContratoId,
                itemReferenciaId: this.subItem.itemReferenciaId,
                descricao: this.descricao.trim(),
                descricaoResumida: this.descricaoResumida.trim(),
                valor: this.valor,
                quantidade: this.quantidade,
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarItemContrato(subItemAtualizadoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterSubItensAtualizados = true
                            this.fecharModalAtualizarSubItem()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registrosInalterados() {
            if (this.descricao) {
                return (
                    this.descricao.trim() == (this.subItem.descricao != null ? this.subItem.descricao.trim() : '') &&
                    this.descricaoResumida.trim() ==
                        (this.subItem.descricaoResumida != null ? this.subItem.descricaoResumida.trim() : '') &&
                    this.valor == this.subItem.valorUnitario &&
                    this.quantidade == this.subItem.quantidade
                )
            }
            return false
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.INICIADO_ADITIVO_CONTRATO
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if(this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-04')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-04')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }

    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return (
                this.atualizacaoContrato() && this.apostilamento
            )
        },
    },

    watch: {},

    validations: {
        itemContratoId: {
            registrosAlterados() {
                return !this.registrosInalterados()
            }
        },
        descricao: {
            required
        },
        valor: {
            required,
            minValue: minValue(0.01)
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
